import Reports from '@/pages/Reports';

export default [
  {
    path: '/reports',
    component: Reports,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        name: 'reports',
        redirect: { name: 'reports.tardiness' },
      },
      {
        path: 'tardiness',
        name: 'reports.tardiness',
        meta: {
          type: 'tardiness',
          permissions: ['perm_generate_report'],
        },
      },
      {
        path: 'overtime',
        name: 'reports.ot',
        meta: {
          type: 'overtime',
          permissions: ['perm_generate_report'],
        },
      },
      {
        path: 'leaves',
        name: 'reports.leaves',
        meta: {
          type: 'leaves',
          permissions: ['perm_generate_report'],
        },
      },
      {
        path: 'timesheet',
        name: 'reports.timesheet',
        meta: {
          type: 'timesheet',
          permissions: ['perm_generate_report'],
        },
      },
    ],
  },
];
